import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ProfileFieldBase from './ProfileFieldBase';

class ProfileSelectField extends Component {
  static propTypes = {
    action: PropTypes.func,
    editable: PropTypes.bool,
    fieldData: PropTypes.string,
    placeHolder: PropTypes.string,
    validations: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  };

  formatDisplayData = data => {
    if (data === 'na') {
      return 'N/A';
    } else {
      return data.charAt(0).toUpperCase() + data.slice(1);
    }
  };

  render = () => {
    return (
      <ProfileFieldBase
        inputTag="select"
        inputTagChildren={this.props.options.map(option => {
          return (
            <option key={option.value} value={option.value}>
              {option.display}
            </option>
          );
        })}
        formatDisplayData={this.formatDisplayData}
        isSelect
        {...this.props}
      />
    );
  };
}

export default ProfileSelectField;



// WEBPACK FOOTER //
// ./src/subscription/profile/components/ProfileSelectField.js